export default {};
export const breakpoints = { XSMALL: 320, SMALL: 480, MEDIUM: 736, LARGE: 960, XLARGE: 1200, XXLARGE: 1440 };
